// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Validate environment variables
if (!SUPABASE_URL) {
  const errorMsg = 'Missing env.VITE_SUPABASE_URL. Please create a .env file with your Supabase credentials. See .env.example for reference.';
  console.error(errorMsg);
  throw new Error(errorMsg);
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  const errorMsg = 'Missing env.VITE_SUPABASE_PUBLISHABLE_KEY. Please create a .env file with your Supabase credentials. See .env.example for reference.';
  console.error(errorMsg);
  throw new Error(errorMsg);
}

// Log configuration (without exposing the key)
console.log('Supabase client initialized:', {
  url: SUPABASE_URL,
  hasKey: !!SUPABASE_PUBLISHABLE_KEY,
  keyLength: SUPABASE_PUBLISHABLE_KEY?.length || 0,
});

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    // Prevent websocket connection until explicitly needed
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {
      'x-client-info': 'sky-high-discover@1.0.0',
    },
  },
});